import { Alert, Button, Stack, Typography } from '@mui/material'

import { useTexts } from '../hooks/useTexts'
import { LocationEditorProps } from '../types'
import { getLocationAccuracy } from '../utils/getLocationAccuracy'

export function LocationAlert(props: LocationEditorProps) {
  const { location, disabled, onConfirmLowAccuracy } = props
  const {
    warning: { lowAccuracy },
  } = useTexts()

  if (disabled) return null

  const accuracy = getLocationAccuracy(location)

  switch (accuracy) {
    case 'low-accuracy':
      return (
        <Alert severity="warning">
          <Stack spacing={1} alignItems="flex-start">
            <Typography variant="body2">{lowAccuracy.description(location.status)}</Typography>
            <Button onClick={onConfirmLowAccuracy}>{lowAccuracy.confirm}</Button>
          </Stack>
        </Alert>
      )
  }
}
